(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7746],{

/***/ 7814:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(7957);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7865);
/* harmony import */ var _styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1__);



var Skelet = function(param) {
    var children = param.children, height = param.height, maxHeight = param.maxHeight, width = param.width, maxWidth = param.maxWidth, style = param.style, className = param.className, invert = param.invert;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: [
            (_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default().skelet),
            className,
            invert && (_styles_modules_Skelet_module_scss__WEBPACK_IMPORTED_MODULE_1___default().invert)
        ].filter(Boolean).join(" "),
        style: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            height: height,
            maxHeight: maxHeight,
            width: width,
            maxWidth: maxWidth
        }, style),
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Skelet);


/***/ }),

/***/ 8718:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _Skelet__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3177);
/* harmony import */ var _styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9984);
/* harmony import */ var _styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var HomeCarouselSkeletonItem = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_modules_Carousel_module_scss__WEBPACK_IMPORTED_MODULE_2___default().carouselItem)
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HomeCarouselSkeletonItem);


/***/ }),

/***/ 9766:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ useIsMount; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useIsMount = function() {
    var isMountRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        isMountRef.current = false;
    }, []);
    return isMountRef.current;
};


/***/ }),

/***/ 7957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(7568);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(828);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(270);
/* harmony import */ var _styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_Footer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3193);
/* harmony import */ var _components_Header__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(798);
/* harmony import */ var _components_home_HomeNewsSkeletonItem__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8718);
/* harmony import */ var _hooks_useIsMount__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(9766);
/* harmony import */ var _context_news__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(9089);
















var generatePagination = function(current, last) {
    var delta = 1;
    var left = current - delta;
    var right = current + delta + 1;
    var range = [];
    var rangeWithDots = [];
    var l;
    for(var i = 1; i <= last; i += 1){
        if (i === 1 || i === last || i >= left && i < right) {
            range.push(i);
        }
    }
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        // eslint-disable-next-line no-restricted-syntax
        for(var _iterator = range[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var i1 = _step.value;
            if (l) {
                if (i1 - l === 2) {
                    rangeWithDots.push(l + 1);
                } else if (i1 - l !== 1) {
                    rangeWithDots.push(null);
                }
            }
            rangeWithDots.push(i1);
            l = i1;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return rangeWithDots;
};
var News = function(param) {
    var dataNews = param.dataNews, current_page = param.current_page, last_page = param.last_page;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), page = ref[0], setPage = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), pages = ref1[0], setPages = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isLoading = ref2[0], setIsLoading = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isLoadingData = ref3[0], setIsLoadingData = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isError = ref4[0], setIsError = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null), data = ref5[0], setData = ref5[1];
    var isMount = (0,_hooks_useIsMount__WEBPACK_IMPORTED_MODULE_10__/* .useIsMount */ .z)();
    var ref6 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_context_news__WEBPACK_IMPORTED_MODULE_11__/* .useNewsProvider */ .r9)(), 2), newsState = ref6[0], setNewsState = ref6[1];
    /** HOOKS */ (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isMount) {
            setPage(current_page);
            setPages(last_page);
            setData(dataNews);
            return;
        }
        var controller = new AbortController();
        var signal = controller.signal;
        var fetchData = function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                var response;
                return _home_baza_node_baza_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.prev = 0;
                            setIsLoadingData(true);
                            _ctx.next = 4;
                            return axios__WEBPACK_IMPORTED_MODULE_5___default().post("https://baza.estate/api/v2" + "/faq/top", {
                                length: 9,
                                page: page
                            }, {
                                signal: signal
                            });
                        case 4:
                            response = _ctx.sent;
                            if (!(!response.data || response.data.status !== "ok")) {
                                _ctx.next = 7;
                                break;
                            }
                            throw new Error(response.data.text);
                        case 7:
                            setPage(response.data.data.current_page);
                            setData(response.data.data.data);
                            setIsLoadingData(false);
                            setIsError(false);
                            _ctx.next = 16;
                            break;
                        case 13:
                            _ctx.prev = 13;
                            _ctx.t0 = _ctx["catch"](0);
                            if (_ctx.t0.code !== "ERR_CANCELED") {
                                setIsLoadingData(false);
                                setIsError(true);
                            }
                        case 16:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee, null, [
                    [
                        0,
                        13
                    ]
                ]);
            }));
            return function fetchData() {
                return _ref.apply(this, arguments);
            };
        }();
        fetchData();
        return function() {
            return controller.abort();
        };
    }, [
        newsState.pagination
    ]);
    var DateFormatter = new Intl.DateTimeFormat("ru-Ru", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
    /** FUNCTIONS */ var handlePagingClick = function(value) {
        var modificator = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
        if (value + modificator === page || value + modificator <= 0 || value + modificator > pages) return;
        setPage(value + modificator);
        setNewsState({
            type: "SET_PAGINATION",
            payload: {
                page: value + modificator
            }
        });
        router.replace("/news?page=" + (value + modificator));
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                title: "Новости недвижимости - страница " + page,
                description: "Новости недвижимости в России: последние новости о недвижимости, ипотеке, спрос, аналитика, изменения в налогах, ключевая ставка, новости росреестра, новости ипотека, блок о недвижимости. Страница:" + page,
                openGraph: {
                    url: "https://".concat("baza.estate", "/faq/"),
                    type: "website",
                    title: "Новости недвижимости - страница" + page,
                    description: "Новости недвижимости в России: последние новости о недвижимости, ипотеке, спрос, аналитика, изменения в налогах, ключевая ставка, новости росреестра, новости ипотека, блок о недвижимости. Страница : " + page,
                    images: [
                        {
                            url: "/images/og-preview.png"
                        }
                    ],
                    site_name: "Baza.estate - база недвижимости"
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Header__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("main", {
                className: "core",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("section", {
                    className: "block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: "fixed",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().newsList),
                                children: [
                                    data && data.length == 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        children: "Новостей нет"
                                    }),
                                    data && data.map(function(value, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react__WEBPACK_IMPORTED_MODULE_2__.Suspense, {
                                            fallback: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_home_HomeNewsSkeletonItem__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("a", {
                                                className: (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().newsListItem),
                                                href: "/".concat(value.slugCategory, "/").concat(value.slug),
                                                children: [
                                                    value.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_6___default()), {
                                                        className: (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().newsListItemImage),
                                                        src: value.image,
                                                        alt: value.slug,
                                                        width: 320,
                                                        height: 240
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().newsListItemContent),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                children: value.title
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().newsItemShortDescription),
                                                                children: value.short_body
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                className: (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().newsListItemFooter),
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                        className: (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().newsListItemCategories),
                                                                        children: value.category.length ? value.category.join(" | ") : ""
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                        className: (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().newsListItemDate),
                                                                        children: DateFormatter.format(new Date(value.created_at))
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }, index);
                                    })
                                ]
                            }),
                            pages > 1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().catalogFooter),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                        className: (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().catalogFooterLeft),
                                        type: "button",
                                        "aria-label": "Предыдущая страница",
                                        onClick: function() {
                                            return handlePagingClick(page, -1);
                                        },
                                        style: {
                                            cursor: page <= 1 ? "not-allowed" : null,
                                            opacity: page <= 1 ? 0.1 : null
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("polyline", {
                                                points: "15 18 9 12 15 6"
                                            })
                                        })
                                    }),
                                    generatePagination(page, pages).map(function(value, index) {
                                        if (!value) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                            children: "..."
                                        }, index);
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                            className: [
                                                (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().catalogFooterButton),
                                                value === page ? (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().active) : ""
                                            ].join(" "),
                                            type: "button",
                                            onClick: function() {
                                                return handlePagingClick(value);
                                            },
                                            style: {
                                                cursor: value === page ? "default" : null
                                            },
                                            children: value
                                        }, index);
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                        className: (_styles_modules_faq_Home_module_scss__WEBPACK_IMPORTED_MODULE_14___default().catalogFooterRight),
                                        type: "button",
                                        "aria-label": "Следующая страница",
                                        onClick: function() {
                                            return handlePagingClick(page, 1);
                                        },
                                        style: {
                                            cursor: page >= pages ? "not-allowed" : null,
                                            opacity: page >= pages ? 0.1 : null
                                        },
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("svg", {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "24",
                                            height: "24",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("polyline", {
                                                points: "9 18 15 12 9 6"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Footer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (News);


/***/ }),

/***/ 9984:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"Carousel_carousel__xlK1e","carouselButton":"Carousel_carouselButton__mZAu9","no-animation":"Carousel_no-animation__JPKuY","no-border":"Carousel_no-border__aJvF6","fullWidth":"Carousel_fullWidth__zWTou","carouselButtonPrevious":"Carousel_carouselButtonPrevious__DjuBK","carouselButtonNext":"Carousel_carouselButtonNext__pkp9m","carouselContent":"Carousel_carouselContent___Mw2_","carouselItem":"Carousel_carouselItem__cTYnB","carouselItemGallery":"Carousel_carouselItemGallery__6w17x","carouselItemCounter":"Carousel_carouselItemCounter__9Vyh3","carouselItemButtons":"Carousel_carouselItemButtons__Mp11T","carouselItemButtonLeft":"Carousel_carouselItemButtonLeft__6FZC2","carouselItemButtonRight":"Carousel_carouselItemButtonRight__oYa2U","carouselItemPhotos":"Carousel_carouselItemPhotos__KE7G_","carouselItemPhoto":"Carousel_carouselItemPhoto__qWC33","carouselItemPhotoHash":"Carousel_carouselItemPhotoHash__rcfRa","carouselItemPhotoMore":"Carousel_carouselItemPhotoMore__7iukH","carouselItemPhotoMoreText":"Carousel_carouselItemPhotoMoreText__aHcS9","carouselItemLabels":"Carousel_carouselItemLabels__88fp8","carouselItemLabelsItem":"Carousel_carouselItemLabelsItem__qGf6q","yellow":"Carousel_yellow__jvp_H","red":"Carousel_red__pgbLW","carouselItemContent":"Carousel_carouselItemContent__TGKh5","carouselItemAddress":"Carousel_carouselItemAddress__RsgW6","carouselItemPrice":"Carousel_carouselItemPrice__qm0BU","green":"Carousel_green__HZZ_8","carouselItemFavorites":"Carousel_carouselItemFavorites__Lgvns","active":"Carousel_active__sQaqJ","carouselItemOldPrice":"Carousel_carouselItemOldPrice__TSjWY","carouselItemInfo":"Carousel_carouselItemInfo__AUmmF","carouselItemProperty":"Carousel_carouselItemProperty__n69rE","carouselItemButton":"Carousel_carouselItemButton__6_XZL","carouselItemActions":"Carousel_carouselItemActions__dKi7i","carouselItemMore":"Carousel_carouselItemMore__RPi_G","carouselItemDummy":"Carousel_carouselItemDummy__QzyQR"};

/***/ }),

/***/ 7865:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"skelet":"Skelet_skelet__Z3L3p","wheeeee":"Skelet_wheeeee__aGXk5","invert":"Skelet_invert__PLaK3"};

/***/ }),

/***/ 270:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"newsList":"Home_newsList__tqWz4","newsListItem":"Home_newsListItem__E3gr8","newsListItemImage":"Home_newsListItemImage__rMyd3","newsListItemContent":"Home_newsListItemContent__x3gVw","newsItemShortDescription":"Home_newsItemShortDescription__s0OLm","newsListItemFooter":"Home_newsListItemFooter__JX2Pr","newsListItemDate":"Home_newsListItemDate__kvLcy","catalogFooter":"Home_catalogFooter__D2D0x","catalogFooterLeft":"Home_catalogFooterLeft__mVZei","catalogFooterRight":"Home_catalogFooterRight__k_4_x","catalogFooterButton":"Home_catalogFooterButton__pk6PT","active":"Home_active__ybqmJ"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [41,2962,5675,798,3193,3924,9774,2888,179], function() { return __webpack_exec__(7814); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);